import { Box, Stack } from "@mui/material";
import { DebugBox } from "@northpowerdev/np-react-utils";
import { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getIcpInspections } from "../../../data/mahiApiConnections";
import { hikoAlert } from "../../../utils/HikoAlert";
import { MahiContext } from "../../state/MahiContext";
import { SearchField } from "../../styled/SearchField";
import { InspectionListTabs } from "./InspectionListTabs";

export default function ConnectListIcpInspections() {

    const location = useLocation()


    const [tabData, setTabData] = useState({
        'Ready': {
            inspections: [], // E.g. [{workOrderId: "0WO6D000000MO6xWAG", workOrderNumber: "00017684", workType: "Builders Temporary Supply"}, ...]
            loading: false,
        },
        'Inspected Recently': {
            inspections: [],
            loading: false,
        },
    })
    const [searchFilter, setSearchFilter] = useState(null)

    const mahiContext = useContext(MahiContext)

    const setInspectionsList = (tabName, inspections) => {
        const newTabData = {...tabData}
        newTabData[tabName].inspections = inspections
        setTabData(newTabData)
    }

   const setInspectionsListLoading = (tabName, isLoading) => {
        const newTabData = {...tabData}
        newTabData[tabName].loading = isLoading
        setTabData(newTabData)
    }

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search)
        const paramICPSearch = searchParams.get('icp_search') // Might be better to do this with a useState depending on location
        setSearchFilter(paramICPSearch)
    }, [location])

    useEffect(() => {
        // Load inspections from web service
        let didCancel = false;
        const abortController = new AbortController()
        console.log('ConnectListIcpInspections useEffect')

        const asyncGetIcpInspections = async (tabName, loadingSetter, stateSetter, abortSignal) => {
            loadingSetter(tabName, true)
            try {
                const IcpInspectionsResponse = await getIcpInspections(mahiContext, tabName, abortSignal)
                if (!didCancel) {
                    stateSetter(tabName, IcpInspectionsResponse)
                }
            } catch {
                hikoAlert('Problem fetching ICP inspections', `We could not find ${tabName} inspections`)
            } finally {
                if (!didCancel) {
                    loadingSetter(tabName, false)
                }
            }
        }
        
        //
        // Load data from web service for each tab
        //
        Object.keys(tabData).forEach((tabName) => {
            asyncGetIcpInspections(
                tabName,
                setInspectionsListLoading,
                setInspectionsList,
                abortController.signal
            ) // run in background

        })

        return (() => {didCancel = true})

    // eslint-disable-next-line
    }, [mahiContext])

    const handleSearchInspections = (filterString) => {
        const trimmedFilterString = filterString?.trim() || filterString
        setSearchFilter(trimmedFilterString)
    }

    return (
        <Box className="Page">
            <Stack direction="row" sx={{flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between'}}>
                <h2 className="np-title">ICP Inspections</h2>
                <Box sx={{}}>
                    <SearchField onSearch={handleSearchInspections} label="Search inspections" defaultText={searchFilter} helperText="ICP number or address" />
                </Box>
            </Stack>

            <InspectionListTabs tabData={tabData} searchFilter={searchFilter} />

            <DebugBox title="tabData" stringify>{tabData}</DebugBox>
        </Box>
    )
}




